var _a;
import { Sizes } from '../../../common/types/Sizes';
export var LinkStyleProperties = (_a = {},
    _a[Sizes.LARGE] = {
        fontSize: '16px',
        lineHeight: '18px',
    },
    _a[Sizes.MEDIUM] = {
        fontSize: '14px',
        lineHeight: '16px',
    },
    _a[Sizes.SMALL] = {
        fontSize: '12px',
        lineHeight: '14px',
    },
    _a[Sizes.X_SMALL] = {
        fontSize: '10px',
        lineHeight: '18px',
    },
    _a);
//# sourceMappingURL=LinkProps.js.map